<template>
  <b-button
    class="w-nowrap mr-2"
    variant="success"
    @click="$emit('onExport')"
  >
    <span>Export .CSV</span>
  </b-button>
</template>

<script>
export default {};
</script>

<style>
</style>